"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _PromoBannerVideo = require("./PromoBannerVideo");
Object.keys(_PromoBannerVideo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _PromoBannerVideo[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _PromoBannerVideo[key];
        }
    });
});
var _PromoBannerImage = require("./PromoBannerImage");
Object.keys(_PromoBannerImage).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _PromoBannerImage[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _PromoBannerImage[key];
        }
    });
});
var _PromoBannerText = require("./PromoBannerText");
Object.keys(_PromoBannerText).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _PromoBannerText[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _PromoBannerText[key];
        }
    });
});
var _PromoBannerSplit = require("./PromoBannerSplit");
Object.keys(_PromoBannerSplit).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _PromoBannerSplit[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _PromoBannerSplit[key];
        }
    });
});
